import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  size?: number;
  children: ReactNode;
  label?: string;
}

/**
 * Круглая кнопка действий с карточки. 44px по дизайну, лёгкий бэкграунд.
 * Если active — заливаем тёмным.
 */
export function IconButton({ active, size = 44, children, label, className = '', ...rest }: Props) {
  return (
    <div className="flex flex-col items-center gap-1">
      <button
        aria-label={label}
        className={[
          'flex items-center justify-center rounded-pill transition',
          active ? 'bg-accent text-text-inverse' : 'bg-surface-soft text-text hover:bg-surface',
          className,
        ].join(' ')}
        style={{ width: size, height: size }}
        {...rest}
      >
        {children}
      </button>
      {label && <span className="text-[11px] text-text-muted">{label}</span>}
    </div>
  );
}
